// client/src/components/forms/SubmitButton.js
//
// The one primary action per form. Full-width, paper background, ink
// border, ink text — visually harmonizing with the inputs above it
// while still reading as pressable. Hover inverts to ink-fill / paper-
// text for the pressed-through feel.
//
// The loading prop swaps the label to "Working…" and disables the
// button. Simple v1 — no spinner. If a caller wants a custom loading
// label, they can leave `loading` off and swap their own children.

export function SubmitButton({
  children,
  loading = false,
  disabled = false,
  className = '',
  ...rest
}) {
  return (
    <button
      type="submit"
      disabled={disabled || loading}
      className={[
        'block w-full',
        'bg-paper text-ink',
        // border-2 (not the -1 on inputs) so it reads as a button, not a field.
        'border-2 border-ink rounded-md',
        'px-4 py-3',
        'text-base font-semibold',
        'hover:bg-ink hover:text-paper',
        'focus:outline-none focus-visible:ring-2 focus-visible:ring-accent focus-visible:ring-offset-2',
        'disabled:opacity-50 disabled:cursor-not-allowed',
        // When disabled, hover shouldn't invert either.
        'disabled:hover:bg-paper disabled:hover:text-ink',
        'transition-colors',
        className,
      ].join(' ')}
      {...rest}
    >
      {loading ? 'Working…' : children}
    </button>
  );
}